import axios from 'axios';

export const saveContact = async (contactData) => {
    try {
        const response = await axios.post('https://infrec.in/php-backend/backend/lead/save-contact-otp.php', {
            name: contactData.name,
            email: contactData.email,
            mobile: contactData.mobile, 
            message: contactData.message,
        });

        return response.data;
    } catch (error) {
        return { success: false, message: error.response?.data?.message || error.message };
    }
};

export const verifyOtp = async (mobile, otp) => {
    try {
        const response = await axios.post('https://infrec.in/php-backend/backend/lead/verify-otp.php', {
            mobile,
            otp
        });
        return response.data;
    } catch (error) {
        return { success: false, message: error.response?.data?.message || error.message };
    }
};

export const resendOtp = async (contactId) => {
    try {
        const response = await axios.post('https://infrec.in/php-backend/backend/lead/resend-otp.php', {
            contactId
        });
        return response.data;
    } catch (error) {
        return { success: false, message: error.response?.data?.message || error.message };
    }
};